import { cn } from '@/utils'
import type { BadgeReason, BadgeStatus } from './model/types'
import { ReasonActionButton } from './ReasonActionButton'

const PILL_CLASS: Record<BadgeStatus, string> = {
  verified: 'border-emerald-200 bg-emerald-50 text-emerald-700',
  needs_review: 'border-amber-300 bg-amber-50 text-amber-700',
  verifying: 'border-neutral-200 bg-neutral-100 text-neutral-600',
}

const PILL_LABEL: Record<BadgeStatus, string> = {
  verified: 'Verified',
  needs_review: 'Needs review',
  verifying: 'Being verified',
}

interface VerdictBadgeProps {
  status: BadgeStatus
  // A rollup's sentence, or the first reason of one account.
  sentence?: string | null
  reason?: BadgeReason | null
  // Reasons beyond the one shown, so a second problem is never hidden.
  moreReasons?: number
  className?: string
}

// Verified is the only green and Needs review the only amber. Every amber pill has a grey reason.
export const VerdictBadge = ({
  status,
  sentence,
  reason,
  moreReasons = 0,
  className,
}: VerdictBadgeProps) => {
  const reasonText = reason?.sentence ?? sentence
  return (
    <div className={cn('flex flex-col items-end gap-1 text-right', className)}>
      <span
        className={cn(
          'inline-flex items-center whitespace-nowrap rounded-full border px-2 py-0.5 text-xs font-medium',
          PILL_CLASS[status],
        )}
      >
        {PILL_LABEL[status]}
      </span>
      {reasonText && (
        <p className="m-0 max-w-[240px] text-xs text-ink-subtle">
          {reasonText}
          {moreReasons > 0 && ` And ${moreReasons} more.`}
        </p>
      )}
      {reason && (
        <div className="mt-1">
          <ReasonActionButton action={reason.action} />
        </div>
      )}
    </div>
  )
}
